import { render } from "./About.vue?vue&type=template&id=0a291a70&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=0a291a70&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0a291a70"

export default script